import { Injectable } from '@angular/core';

import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {
    
   

    arrayBuffer: any;
    file: File;

  public async exportAsExcelFile(json: any[], excelFileName: string, headers?: { [key: string]: string }): Promise<void> {
    if (!json || json.length === 0) {
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Dados');

    const columns: Partial<ExcelJS.Column>[] = Object.keys(json[0]).map(key => ({
      header: headers && headers[key] ? headers[key] : key.toUpperCase(),
      key: key,
      width: 20
    }));

    worksheet.columns = columns;

    // Adiciona os dados
    json.forEach(item => {
      worksheet.addRow(item);
    });

    // Estiliza o cabeçalho (primeira linha)
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF4CAF50' }
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Estiliza as demais linhas
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber === 1) return; // pula o cabeçalho
      row.eachCell((cell) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    });

    // Gera o arquivo e salva
    const buffer = await workbook.xlsx.writeBuffer();
    this.saveAsExcelFile(buffer, excelFileName);
  }
    
    public exportAsExcelFileTwoAbas(json: any[], total: any[], excelFileName: string, aux?): void {	
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);	
        const worksheet2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(total);	
        let workbook: XLSX.WorkBook
        if(aux == 'fretes'){
             workbook  = { 	
                Sheets: { 'Dados Gerais': worksheet, 'Configurações': worksheet2 }, 	
                SheetNames: ['Dados Gerais', 'Configurações'] 	
            };
        } else {
             workbook = { 	
                Sheets: { 'data': worksheet, 'total': worksheet2 }, 	
                SheetNames: ['data', 'total'] 	
            };	
        }
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });	
        this.saveAsExcelFile(excelBuffer, excelFileName);	
    	
    }
    
    public exportAsExcelFileFiveAbas(relatorio: any[], resumoDespesa: any[], resumoConsultor: any[], resumoPagto: any[], resumoConsPagto: any[], excelFileName: string): void {	
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(relatorio);	
        const worksheet2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(resumoDespesa);	
        const worksheet3: XLSX.WorkSheet = XLSX.utils.json_to_sheet(resumoConsultor);	
        const worksheet4: XLSX.WorkSheet = XLSX.utils.json_to_sheet(resumoPagto);	
        const worksheet5: XLSX.WorkSheet = XLSX.utils.json_to_sheet(resumoConsPagto);
       
            
        const workbook: XLSX.WorkBook = { 	
            Sheets: { 'Relatório': worksheet, 'Resumo Tipo Despesa': worksheet2, 'Resumo Consultor': worksheet3, 'Resumo Tipo Pagamento': worksheet4, 'Resumo Consultor e Forma Pgto': worksheet5 }, 	
            SheetNames: ['Relatório', 'Resumo Tipo Despesa', 'Resumo Consultor', 'Resumo Tipo Pagamento', 'Resumo Consultor e Forma Pgto'] 	
        };	
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });	
        this.saveAsExcelFile(excelBuffer, excelFileName);	
    	
    }


    private async saveAsExcelFile(buffer: ArrayBuffer, fileName: string): Promise<void> {
        const data: Blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const now = new Date();
        const dataFormatada = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()}`;
        FileSaver.saveAs(data, `${fileName} (${dataFormatada}).xlsx`);
      }

    incomingfile(event) {
        this.file = event.target.files[0]; 
    }

    Upload() {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
              this.arrayBuffer = fileReader.result;
              const data = new Uint8Array(this.arrayBuffer);
              const arr = [];
              for (let i = 0; i != data.length; ++i) { arr[i] = String.fromCharCode(data[i]); }
              const bstr = arr.join('');
              const workbook = XLSX.read(bstr, {type: 'binary'});
              const first_sheet_name = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[first_sheet_name];
              console.log(XLSX.utils.sheet_to_json(worksheet, {raw: true}));
          };
        fileReader.readAsArrayBuffer(this.file);
  }
}
